<nav class="mobile-nav-menu d-flex flex-column d-lg-none" role="navigation" aria-label="Mobile navigation">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between align-items-center">
    <a class="nav-brand" [routerLink]="['/']" aria-label="Go to homepage">
      <img class="home-logo" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" alt="Fortress logo" />
    </a>

    <div class="right-mobile-nav-container">
      <button
        class="nav-toggler"
        (click)="isCollapsed = !isCollapsed"
        [attr.aria-expanded]="!isCollapsed"
        aria-controls="mobile-nav-dropdown"
        aria-label="Open navigation menu"
      >
        <span class="material-icons" aria-hidden="true">menu</span>
      </button>
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div
    id="mobile-nav-dropdown"
    [ngbCollapse]="isCollapsed"
    class="mobile-nav-dropdown"
    role="dialog"
    aria-modal="true"
    aria-label="Navigation menu"
  >
    <div class="mobile-nav-content">
      <!-- Header -->
      <div class="nav-header">
        <a [routerLink]="['/']" aria-label="Go to homepage">
          <img class="home-logo" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" alt="Fortress logo" />
        </a>
        <button class="close-btn" (click)="isCollapsed = !isCollapsed" aria-label="Close navigation menu">
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button>
      </div>

      <!-- Nav Links -->
      <ul class="nav-list" role="list">
        <li>
          <a class="nav-link" [routerLink]="['/earn']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <span class="material-symbols-outlined nav-icon" aria-hidden="true">money</span>
            <span class="nav-label">{{ 'nav.earn' | translate }}</span>
          </a>
        </li>

        <!-- Help accordion -->
        <li class="nav-accordion">
          <button
            class="nav-link nav-accordion-toggle"
            (click)="isHelpOpen = !isHelpOpen"
            [attr.aria-expanded]="isHelpOpen"
            aria-controls="help-submenu"
          >
            <span class="material-symbols-outlined nav-icon" aria-hidden="true">info</span>
            <span class="nav-label">{{ 'nav.help' | translate }}</span>
            <span class="material-symbols-outlined accordion-chevron" [class.open]="isHelpOpen" aria-hidden="true"
              >keyboard_arrow_right</span
            >
          </button>

          <ul id="help-submenu" class="nav-submenu" [ngbCollapse]="!isHelpOpen" role="list">
            <li>
              <a class="nav-sublink" [routerLink]="['/terms']" [routerLinkActive]="'active'">
                {{ 'nav.terms' | translate }}
              </a>
            </li>
            <li>
              <a class="nav-sublink" [routerLink]="['/faq']" [routerLinkActive]="'active'">
                {{ 'nav.faq' | translate }}
              </a>
            </li>
            <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.contact.us'">
              <li>
                <a class="nav-sublink" [routerLink]="['/contact']" [routerLinkActive]="'active'">
                  {{ 'nav.contact.us' | translate }}
                </a>
              </li>
            </ng-container>
          </ul>
        </li>
      </ul>

      <!-- Log Out -->
      <div class="nav-footer">
        <button class="logout-btn" (click)="logout()" aria-label="Log out of your account">
          <span class="material-symbols-outlined" aria-hidden="true">logout</span>
          <span>{{ 'nav.log.out' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</nav>
